// Auto-generated by scripts/regen_neighborhood_vocab.py — do not
// hand-edit. Sourced from app/services/neighborhood_vocab.py +
// the myhome_districts/myhome_urbans tables.

export interface NeighborhoodItem {
  value: string;  // myhome urban slug (also the HotOffer.neighborhood code)
  label: string;  // English display name (Latin)
  labelKa: string; // Georgian display name
}

export interface NeighborhoodGroup {
  /** English district name. */
  label: string;
  /** Georgian district name. */
  labelKa: string;
  /** District slug (matches myhome_districts.slug). */
  adminCode: string;
  items: NeighborhoodItem[];
}

export const NEIGHBORHOOD_GROUPS: NeighborhoodGroup[] = [
  {
    label: 'Gldani-Nadzaladevi',
    labelKa: 'გლდანი-ნაძალადევი',
    adminCode: 'gldani-nadzaladevi',
    items: [
      { value: 'avshniani', label: 'Avshniani', labelKa: 'ავშნიანი' },
      { value: 'avtchala', label: 'Avchala', labelKa: 'ავჭალა' },
      { value: 'giorgiwmindas-dasakhleba', label: 'Giorgitsminda Dasakhleba', labelKa: 'გიორგიწმინდას დასახლება' },
      { value: 'gldani', label: 'Gldani', labelKa: 'გლდანი' },
      { value: 'gldanula', label: 'Gldanula', labelKa: 'გლდანულა' },
      { value: 'zahesi', label: 'Zahesi', labelKa: 'ზაჰესი' },
      { value: 'tbilisis-zghva', label: 'Tbilisi sea', labelKa: 'თბილისის ზღვა' },
      { value: 'temqa', label: 'Temqa', labelKa: 'თემქა' },
      { value: 'koniakis-dasakhleba', label: 'Koniaki Dasakhleba', labelKa: 'კონიაკის დასახლება' },
      { value: 'lotkini', label: 'Lotkini', labelKa: 'ლოტკინი' },
      { value: 'mukhiani', label: 'Mukhiani', labelKa: 'მუხიანი' },
      { value: 'nadzaladevi', label: 'Nadzaladevi', labelKa: 'ნაძალადევი' },
      { value: 'san-zona', label: 'Sanzona', labelKa: 'სან. ზონა' },
      { value: 'sop-gldani', label: 'Gldani village', labelKa: 'სოფ. გლდანი' },
    ],
  },
  {
    label: 'Suburbs of Tbilisi',
    labelKa: 'თბილისის შემოგარენი',
    adminCode: 'tbilisis-shemogareni',
    items: [
      { value: 'akhaldaba', label: 'Akhaldaba', labelKa: 'ახალდაბა' },
      { value: 'betania', label: 'Betania', labelKa: 'ბეთანია' },
      { value: 'zemo-lisi', label: 'Upper Lisi', labelKa: 'ზემო ლისი' },
      { value: 'kaklebi', label: 'Kaklebi', labelKa: 'კაკლები' },
      { value: 'kveseti', label: 'Kveseti', labelKa: 'კვესეთი' },
      { value: 'kiketi', label: 'Kiketi', labelKa: 'კიკეთი' },
      { value: 'kojori', label: 'Kojori', labelKa: 'კოჯორი' },
      { value: 'mskhaldidi', label: 'Mskhaldidi', labelKa: 'მსხალდიდი' },
      { value: 'oqroyana', label: 'Oqrokana', labelKa: 'ოქროყანა' },
      { value: 'tabakhmela', label: 'Tabakhmela', labelKa: 'ტაბახმელა' },
      { value: 'shindisi', label: 'Shindisi', labelKa: 'შინდისი' },
      { value: 'wavkisi', label: 'Tsavkisi', labelKa: 'წავკისი' },
      { value: 'wveri', label: 'Tsveri', labelKa: 'წვერი' },
      { value: 'wodoreti', label: 'Tsodoreti', labelKa: 'წოდორეთი' },
      { value: 'wyneti', label: 'Tskneti', labelKa: 'წყნეთი' },
    ],
  },
  {
    label: 'Didube-Chugureti',
    labelKa: 'დიდუბე-ჩუღურეთი',
    adminCode: 'didube-chughureti',
    items: [
      { value: 'didube', label: 'Didube', labelKa: 'დიდუბე' },
      { value: 'dighmis-masivi', label: 'Digomi', labelKa: 'დიღმის მასივი' },
      { value: 'ivertubani', label: 'Ivertuban', labelKa: 'ივერთუბანი' },
      { value: 'kukia', label: 'Kukia', labelKa: 'კუკია' },
      { value: 'svanetis-ubani', label: 'Svanetis ubani', labelKa: 'სვანეთის უბანი' },
      { value: 'chughureti', label: 'Chugureti', labelKa: 'ჩუღურეთი' },
    ],
  },
  {
    label: 'Vake-Saburtalo',
    labelKa: 'ვაკე-საბურთალო',
    adminCode: 'vake-saburtalo',
    items: [
      { value: 'bagebi', label: 'Bagebi', labelKa: 'ბაგები' },
      { value: 'didgori', label: 'Didgori', labelKa: 'დიდგორი' },
      { value: 'didi-dighomi', label: 'Didi digomi', labelKa: 'დიდი დიღომი' },
      { value: 'dighmis-tchala', label: 'Dighomi Tchala', labelKa: 'დიღმის ჭალა' },
      { value: 'dighomi-1-9', label: 'Digomi 1-9', labelKa: 'დიღომი 1-9' },
      { value: 'vake', label: 'Vake', labelKa: 'ვაკე' },
      { value: 'vashlijvari', label: 'Vashlijvari', labelKa: 'ვაშლიჯვარი' },
      { value: 'vedzisi', label: 'Vedzisi', labelKa: 'ვეძისი' },
      { value: 'tkhinvali', label: 'Tkhinvali', labelKa: 'თხინვალი' },
      { value: 'kus-tba', label: 'Turtle lake', labelKa: 'კუს ტბა' },
      { value: 'lisi', label: 'Lisi lake', labelKa: 'ლისი' },
      { value: 'lisis-mimdebared', label: 'Lisi lake', labelKa: 'ლისის მიმდებარედ' },
      { value: 'mukhatgverdi', label: 'Mukhatgverdi', labelKa: 'მუხათგვერდი' },
      { value: 'mukhatwyaro', label: 'Mukhattskaro', labelKa: 'მუხათწყარო' },
      { value: 'nucubidzis-perdobi', label: 'Nutsubidze plateau', labelKa: 'ნუცუბიძის ფერდობი' },
      { value: 'saburtalo', label: 'Saburtalo', labelKa: 'საბურთალო' },
      { value: 'sop-dighomi', label: 'Sop. Dighomi', labelKa: 'სოფ. დიღომი' },
      { value: 'qoshigora', label: 'Koshigora', labelKa: 'ქოშიგორა' },
    ],
  },
  {
    label: 'Isani-Samgori',
    labelKa: 'ისანი-სამგორი',
    adminCode: 'isani-samgori',
    items: [
      { value: 'aeroportis-dasakhleba', label: 'Airport Dasakhleba', labelKa: 'აეროპორტის დასახლება' },
      { value: 'aprika', label: 'Africa', labelKa: 'აფრიკა' },
      { value: 'dampalos-dasakhleba', label: 'Dampalo Dasakhleba', labelKa: 'დამპალოს დასახლება' },
      { value: 'vazisubani', label: 'Vazisubani', labelKa: 'ვაზისუბანი' },
      { value: 'varketili', label: 'Varketili', labelKa: 'ვარკეთილი' },
      { value: 'isani', label: 'Isani', labelKa: 'ისანი' },
      { value: 'lilo', label: 'Lilo', labelKa: 'ლილო' },
      { value: 'mesame-masivi', label: 'Mesame masivi', labelKa: 'მესამე მასივი' },
      { value: 'moskovis-gamziri', label: 'Moscow Ave', labelKa: 'მოსკოვის გამზირი' },
      { value: 'navtlughi', label: 'Navtlugi', labelKa: 'ნავთლუღი' },
      { value: 'orkhevi', label: 'Orkhevi', labelKa: 'ორხევი' },
      { value: 'samgori', label: 'Samgori', labelKa: 'სამგორი' },
      { value: 'ponitchala', label: 'Ponichala', labelKa: 'ფონიჭალა' },
    ],
  },
  {
    label: 'Old Tbilisi',
    labelKa: 'ძველი თბილისი',
    adminCode: 'dzveli-tbilisi',
    items: [
      { value: 'abanotubani', label: 'Abanotubani', labelKa: 'აბანოთუბანი' },
      { value: 'avlabari', label: 'Avlabari', labelKa: 'ავლაბარი' },
      { value: 'elia', label: 'Elia', labelKa: 'ელია' },
      { value: 'vera', label: 'Vera', labelKa: 'ვერა' },
      { value: 'krwanisi', label: 'Krtsanisi', labelKa: 'კრწანისი' },
      { value: 'mtawminda', label: 'Mtatsminda', labelKa: 'მთაწმინდა' },
      { value: 'ortatchala', label: 'Ortachala', labelKa: 'ორთაჭალა' },
      { value: 'sololaki', label: 'Sololaki', labelKa: 'სოლოლაკი' },
      { value: 'wavkisis-veli', label: 'Tsavkis Valley', labelKa: 'წავკისის ველი' },
    ],
  },
];

export const NEIGHBORHOOD_LABELS: Record<string, string> = Object.fromEntries(NEIGHBORHOOD_GROUPS.flatMap((g) => g.items.map((i) => [i.value, i.label])));

export const NEIGHBORHOOD_LABELS_KA: Record<string, string> = Object.fromEntries(NEIGHBORHOOD_GROUPS.flatMap((g) => g.items.map((i) => [i.value, i.labelKa])));

// Old 33-code names (used by saved client filters / bookmarked
// market URLs) → new myhome slug. ALL_NEIGHBORHOOD_CODES contains
// the new slugs only; the alias map keeps legacy URLs working.
export const NEIGHBORHOOD_OLD_TO_NEW: Record<string, string> = {
  'didi_dighomi': 'didi-dighomi',
  'dighomi': 'dighomi-1-9',
  'dighmis_masivi': 'dighmis-masivi',
  'nutsubidze': 'nucubidzis-perdobi',
  'mtatsminda': 'mtawminda',
  'ortachala': 'ortatchala',
  'krtsanisi': 'krwanisi',
  'tbilisi_sea': 'tbilisis-zghva',
  'sanzona': 'san-zona',
  'temka': 'temqa',
};

